export default "__VITE_ASSET__4a1aaa92__"